import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different signin action types
*/
let initialstate = {
  isLoading: false,
  users: [],
  pagination: {},
  sorter: {},
  searchText: '',
  active: true,
}
export default function user_operations(state = { ...initialstate }, action) {
  switch (action.type) {
    case ActionType.USER_INPROGRESS:
      return { ...state, isLoading: action.isLoading }
    case ActionType.USER_LIST:
      return {
        ...state,
        isLoading: action.isLoading,
        users: action.users,
        pagination: action.pagination,
        sorter: action.sorter,
        searchText: action.searchText,
        active: action.active,
      }
    case ActionType.LOGIN_AS_COMPANY:
      return {
        ...state,
        isLoading: false,
        users: [],
        pagination: {},
        sorter: {},
        searchText: '',
        active: true,
      }
    case ActionType.LOGOUT:
      return initialstate
    default:
      return state
  }
}
